<app-breadcrumbs [headerTitle]="'PAYGROUPS'" />
<div class="main-container">
	<app-customer-list (newCustomerSelectedEvent)="customerSelected($event)"></app-customer-list>
</div>
